import { onUnexpectedError } from "./errors";
import { LinkedList } from "./linkedList";
const _Emitter = class _Emitter {
  constructor() {
    this._listeners = new LinkedList();
    this._disposed = false;
  }
  get event() {
    if (!this._event) {
      this._event = (listener) => {
        if (!this._listeners) {
          this._listeners = new LinkedList();
        }
        const remove = this._listeners.push(listener);
        const result = {
          dispose: () => {
            result.dispose = _Emitter._noop;
            if (!this._disposed) {
              remove();
            }
          }
        };
        return result;
      };
    }
    return this._event;
  }
  /**
   * To be kept private to fire an event to
   * subscribers
   */
  fire(event) {
    if (this._listeners) {
      if (!this._deliveryQueue) {
        this._deliveryQueue = new LinkedList();
      }
      for (const listener of this._listeners) {
        this._deliveryQueue.push([listener, event]);
      }
      while (this._deliveryQueue.size > 0) {
        const [listener, event2] = this._deliveryQueue.shift();
        try {
          listener.call(void 0, event2);
        } catch (e) {
          onUnexpectedError(e);
        }
      }
    }
  }
  dispose() {
    var _a;
    if (!this._disposed) {
      this._disposed = true;
      (_a = this._listeners) == null ? void 0 : _a.clear();
    }
  }
};
_Emitter._noop = () => {
};
let Emitter = _Emitter;
export {
  Emitter
};
